<template>
  <div><employee-list></employee-list></div>
</template>
<script>
import EmployeeList from "@/components/EmployeeList";

export default {
  name: "Employee",
  components: {
    EmployeeList
  }
};
</script>
